/* ALFA "Your line" tray — the storefront's replacement for a cart. Products
   collect here (localStorage, no checkout anywhere) and the single action is
   continuing into the AI Brand Studio with the whole line pre-loaded.
   Buttons opt in via [data-alfa-line-add] with data-handle / data-title /
   data-image. The tray + chip markup renders from snippets/alfa-line-drawer. */
(function () {
  'use strict';
  var KEY = 'alfa_line_v1';
  var STUDIO_URL = (window.ALFA_STUDIO_URL || 'https://start.alfamfg.com/studio');

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items.slice(0, 20))); } catch (e) { /* private mode */ }
    render();
  }

  function $(sel) { return document.querySelector(sel); }

  function render() {
    var items = read();
    var chip = $('#AlfaLineChip');
    var count = $('#AlfaLineCount');
    var list = $('#AlfaLineItems');
    var empty = $('#AlfaLineEmpty');
    var cta = $('#AlfaLineCta');
    if (chip) chip.hidden = items.length === 0;
    if (count) count.textContent = String(items.length);
    if (cta) {
      cta.href = STUDIO_URL + (items.length ? '?add=' + items.map(function (i) { return encodeURIComponent(i.h); }).join(',') : '');
      cta.style.display = items.length ? '' : 'none';
    }
    if (empty) empty.style.display = items.length ? 'none' : '';
    if (list) {
      list.innerHTML = '';
      items.forEach(function (i) {
        var row = document.createElement('div');
        row.className = 'alfa-line-item';
        var img = document.createElement('div');
        img.className = 'alfa-line-item__img';
        if (i.img) { var im = document.createElement('img'); im.src = i.img; im.alt = ''; im.loading = 'lazy'; img.appendChild(im); }
        var t = document.createElement('div');
        t.className = 'alfa-line-item__t';
        var a = document.createElement('a');
        a.href = '/products/' + i.h;
        a.textContent = i.t || i.h;
        t.appendChild(a);
        var rm = document.createElement('button');
        rm.className = 'alfa-line-item__rm';
        rm.setAttribute('aria-label', 'Remove from line');
        rm.textContent = '✕';
        rm.addEventListener('click', function () { remove(i.h); });
        row.appendChild(img); row.appendChild(t); row.appendChild(rm);
        list.appendChild(row);
      });
    }
    // Reflect "on line" state on any add buttons present.
    document.querySelectorAll('[data-alfa-line-add]').forEach(function (btn) {
      var h = btn.getAttribute('data-handle');
      var on = items.some(function (i) { return i.h === h; });
      btn.classList.toggle('is-added', on);
      var label = btn.getAttribute(on ? 'data-label-added' : 'data-label');
      if (label) btn.textContent = label;
    });
  }

  function add(handle, title, img) {
    if (!handle) return;
    var items = read();
    if (!items.some(function (i) { return i.h === handle; })) {
      items.push({ h: handle, t: title || '', img: img || '' });
      write(items);
    }
    open();
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.h !== handle; }));
  }

  function open() {
    var tray = $('#AlfaLineTray'); var ov = $('#AlfaLineOverlay');
    if (tray) tray.classList.add('is-open');
    if (ov) ov.classList.add('is-open');
  }
  function close() {
    var tray = $('#AlfaLineTray'); var ov = $('#AlfaLineOverlay');
    if (tray) tray.classList.remove('is-open');
    if (ov) ov.classList.remove('is-open');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-alfa-line-add]');
    if (btn) {
      e.preventDefault();
      add(btn.getAttribute('data-handle'), btn.getAttribute('data-title'), btn.getAttribute('data-image'));
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var chip = $('#AlfaLineChip'); if (chip) chip.addEventListener('click', open);
    var closeBtn = $('#AlfaLineClose'); if (closeBtn) closeBtn.addEventListener('click', close);
    var ov = $('#AlfaLineOverlay'); if (ov) ov.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    render();
  });

  window.AlfaLine = { add: add, remove: remove, open: open, close: close, items: read };
})();
